import { Route, Navigate } from "react-router";
import Login from "../features/auth/Login";
import BridgeAuthPage from "../features/auth/BridgeAuthPage";
import { ENDPOINTS } from "../common/utils/url-registry";
import { VITE_PUBLIC_ENV } from "@common/utils/constants";
import NotFoundPage from "../common/components/NotFound";
import AsyncComponent from "./AsyncComponent";
import { UnAuthenticatedLayout } from "./UnAuthenticatedLayout";
import TestErrorRoute, { isTestErrorRouteEnabled, TEST_ERROR_ROUTE } from "./TestErrorRoute";

export function UnAuthenticatedRoutes() {
    return (
        <>
            <Route
                index
                handle={{ title: "Sign In" }}
                element={
                    <UnAuthenticatedLayout>
                        <Login />
                    </UnAuthenticatedLayout>
                }
            />
            <Route
                path={"/login"}
                handle={{ title: "Sign In" }}
                element={
                    <UnAuthenticatedLayout>
                        <Login />
                    </UnAuthenticatedLayout>
                }
            />
            <Route
                path={`/${ENDPOINTS.BridgeAuth}`}
                handle={{ title: "Authorize" }}
                element={
                    <UnAuthenticatedLayout>
                        <BridgeAuthPage />
                    </UnAuthenticatedLayout>
                }
            />
            <Route
                path={ENDPOINTS.SignUp}
                handle={{ title: "Sign Up" }}
                element={
                    <UnAuthenticatedLayout>
                        <AsyncComponent loadComponent={() => import("../features/auth/SignUp")} />
                    </UnAuthenticatedLayout>
                }
            />
            <Route
                path={ENDPOINTS.ResetPassword}
                handle={{ title: "Set or Reset Password" }}
                element={
                    <UnAuthenticatedLayout>
                        <AsyncComponent loadComponent={() => import("../features/auth/ResetPassword")} />
                    </UnAuthenticatedLayout>
                }
            />
            <Route
                path={ENDPOINTS.ResendVerificationEmail}
                handle={{ title: "Resend Verification" }}
                element={
                    <UnAuthenticatedLayout>
                        <AsyncComponent loadComponent={() => import("@/features/auth/ResendVerificationEmail")} />
                    </UnAuthenticatedLayout>
                }
            />
            <Route path={ENDPOINTS.EmailVerified} element={<Navigate to="/" replace />} />
            {/* Same as AuthenticatedRoutes: magic-link may land before session is set; unauthenticated router must match URL. */}
            <Route
                path={ENDPOINTS.AcceptInvite}
                handle={{ title: "Accept Invite" }}
                element={<AsyncComponent loadComponent={() => import("@features/auth/AcceptInvite")} />}
            />
            <Route
                path="/checkout/:session_id"
                handle={{ title: "Checkout" }}
                element={
                    <UnAuthenticatedLayout>
                        <AsyncComponent loadComponent={() => import("@/features/checkout/CustomerCheckoutPage")} />
                    </UnAuthenticatedLayout>
                }
            />
            <Route
                path="/checkout/:session_id/success"
                handle={{ title: "Checkout Complete" }}
                element={
                    <UnAuthenticatedLayout>
                        <AsyncComponent loadComponent={() => import("@/features/checkout/SuccessPage")} />
                    </UnAuthenticatedLayout>
                }
            />
            {isTestErrorRouteEnabled(VITE_PUBLIC_ENV) && (
                <Route path={TEST_ERROR_ROUTE} handle={{ title: "Test Error" }} element={<TestErrorRoute />} />
            )}
            <Route
                path="*"
                handle={{ title: "Not Found" }}
                element={
                    <UnAuthenticatedLayout>
                        <NotFoundPage />
                    </UnAuthenticatedLayout>
                }
            />
        </>
    );
}
